/**
 * 浮点数乘法
 */
export function accMul(arg1, arg2) {
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    const s1spt = s1.split(".");
    m += (s1spt[1] && s1spt[1].length) || 0;
  } catch (e) {
    console.log(e);
  }
  try {
    const s2spt = s2.split(".");
    m += (s2spt[1] && s2spt[1].length) || 0;
  } catch (e) {
    console.log(e);
  }
  return (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m);
}

/**
 * 浮点数除法
 */
export function accDiv(arg1, arg2) {
  let t1 = 0;
  let t2 = 0;

  try {
    const spt1 = arg1.toString().split(".");
    t1 = (spt1[1] && spt1[1].length) || 0;
  } catch (e) {
    console.log(e);
  }
  try {
    const spt2 = arg2.toString().split(".");
    t2 = (spt2[1] && spt2[1].length) || 0;
  } catch (e) {
    console.log(e);
  }
  const r1 = Number(arg1.toString().replace(".", ""));
  const r2 = Number(arg2.toString().replace(".", ""));
  return accMul(r1 / r2, Math.pow(10, t2 - t1));
}

/**
 * 浮点数加法
 */
export function accAdd(a, b) {
  let c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return (e = Math.pow(10, Math.max(c, d))), (accMul(a, e) + accMul(b, e)) / e;
}

/**
 * 浮点数减法
 */
export function accSub(a, b) {
  let c, d, e;
  try {
    c = a.toString().split(".")[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split(".")[1].length;
  } catch (f) {
    d = 0;
  }
  return (e = Math.pow(10, Math.max(c, d))), (accMul(a, e) - accMul(b, e)) / e;
}

/**
 * 数字添加千分符
 */
export function thousandSeparator(num) {
  const res = num?.toString().replace(/\d+/, (n) => {
    return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
      return $1 + ",";
    });
  });
  return res;
}

/**
 * 数字转换，解决浮点数精度丢失问题
 * @param val 数字或者string的数字
 * @param val1 数字或者string的数字 需要加减乘除法的对象
 * @param type 1 multiply 2 divide 3 plus 4 minus
 */
export function floatingPointNumber({ val, val1, type }) {
  if (!/^[0-9]*\.?[0-9]*$/.test(val.toString()) || !/^[0-9]*\.?[0-9]*$/.test(val1.toString())) {
    console.log("传入的值必须是数字");
    return;
  }
  const multiply = (val, val1) => {
    const valString = val.toString();
    const val1String = val1.toString();
    const valDigits = (valString.split(".")[1] || "").length;
    const val1Digits = (val1String.split(".")[1] || "").length;
    const baseNum = Math.pow(10, valDigits + val1Digits);
    return (Number(valString.replace(".", "")) * Number(val1String.replace(".", ""))) / baseNum;
  };
  const plus = (val, val1) => {
    const valDigits = (val.toString().split(".")[1] || "").length;
    const val1Digits = (val1.toString().split(".")[1] || "").length;
    const baseNum = Math.pow(10, Math.max(valDigits, val1Digits));
    return (multiply(val, baseNum) + multiply(val1, baseNum)) / baseNum;
  };
  const minus = (val, val1) => {
    const valDigits = (val.toString().split(".")[1] || "").length;
    const val1Digits = (val1.toString().split(".")[1] || "").length;
    const baseNum = Math.pow(10, Math.max(valDigits, val1Digits));
    return (multiply(val, baseNum) - multiply(val1, baseNum)) / baseNum;
  };
  const divide = (val, val1) => {
    let t1 = 0;
    let t2 = 0;
    try {
      t1 = (val.toString().split(".")[1] || "").length;
    } catch (e) {
      console.log(e);
    }
    try {
      t2 = (val1.toString().split(".")[1] || "").length;
    } catch (e) {
      console.log(e);
    }
    const r1 = Number(val.toString().replace(".", ""));
    const r2 = Number(val1.toString().replace(".", ""));
    return multiply(r1 / r2, t1 - t2 > 0 ? 1 / Math.pow(10, t1 - t2) : Math.pow(10, t2 - t1));
  };

  switch (type) {
    case 1:
      return multiply(val, val1);
    case 2:
      return divide(val, val1);
    case 3:
      return plus(val, val1);
    case 4:
      return minus(val, val1);
  }
}

/**
 * 阿拉伯数字转中文数字
 */
export function NoToChinese(num) {
  if (!/^\d*(\.\d*)?$/.test(num.toString())) {
    return "Number is wrong!";
  }
  const AA = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  const BB = ["", "十", "百", "千", "万", "亿", "点", ""];
  const a = ("" + num).replace(/(^0*)/g, "").split(".");
  let k = 0;
  let re = "";
  for (let i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re;
        break;
      case 4:
        if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0])) {
          re = BB[4] + re;
        }
        break;
      case 8:
        re = BB[5] + re;
        BB[7] = BB[5];
        k = 0;
        break;
    }
    if (k % 4 === 2 && +a[0].charAt(i + 2) !== 0 && +a[0].charAt(i + 1) === 0) {
      re = AA[0] + re;
    }
    if (+a[0].charAt(i) !== 0) {
      re = AA[+a[0].charAt(i)] + BB[k % 4] + re;
    }
    k++;
  }
  if (a.length > 1) {
    re += BB[6];
    for (let i = 0; i < a[1].length; i++) {
      re += AA[+a[1].charAt(i)];
    }
  } // 加上小数部分(如果有小数部分)
  return re;
}
